module.exports = __webpack_public_path__ + "media/images/site/oficial_background-56e538676d7bdc5557005b50a7aa1c13.png";